import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateCustomSafe } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useCreateCustomSafe = () => {
  const { invalidateQuery: invalidateViewQueries } = useInvalidateQueries(
    QueryKey.GET_SCENARIO_CUSTOM_SAFES,
  );

  const { mutate: createCustomSafe, isPending } = useAppMutation(
    [QueryKey.CREATE_SCENARIO_CUSTOM_SAFE],
    {
      mutationFn: ({ scenarioId, data }: { data: CreateCustomSafe; scenarioId: string }) =>
        ApiService.post(
          { endpoint: BackendRoute.SCENARIOS, routePath: [scenarioId, 'custom-safes'] },
          { body: data },
        ),

      onSuccess: () => {
        invalidateViewQueries();
      },
    },
  );
  return { createCustomSafe, isPending };
};
